import type {
	RecommendationsList$data,
	JiraProjectRecommendationType,
} from '@atlassian/jira-relay/src/__generated__/RecommendationsList.graphql';

export type Recommendation = Omit<
	NonNullable<NonNullable<NonNullable<RecommendationsList$data['edges']>[number]>['node']>,
	' $fragmentSpreads'
>;

export const countRecommendationsByType = (
	recommendations: ReadonlyArray<Recommendation>,
	type: JiraProjectRecommendationType,
): number => {
	return recommendations.filter((rec) => rec.details?.recommendationType === type).length;
};

export const getFirstInviterProjectId = (
	recommendations: ReadonlyArray<Recommendation>,
): string | undefined => {
	return recommendations.find((rec) => rec.details?.recommendationType === 'INVITER_ACTIVITY')
		?.project?.projectId;
};
